import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { contactType } from '@Components/Utilities/SandhillsConstants';
import { formatPrintPageDate } from '@Components/Utilities/SandhillsUtility';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import MainDetailPricing from '@Components/Detail/MainDetailPricing';
import InspectionList from '@Components/Detail/InspectionList';
import DealerInfo from '@Components/Detail/DealerInfo';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { ThemedLink } from '@Components/MuiWrappers/ThemedLink';
import Icon from '@mui/material/Icon';

const PrintDetail = (props) => {

    const getDefaultParagraphText = () => {
        return translator.getPlainTextPhrase('sandhills.tradepubwebsite.mvc.showasparagraph');
    };

    const [toggleThumbnailText, setToggleThumbnailText] = useState(translator.getPlainTextPhrase('sandhills.tradepubwebsite.mvc.hidethumbnails'));
    const [toggleSpecParagraphText, setToggleSpecParagraphText] = useState(getDefaultParagraphText());
    const [toggleInspectionParagraphText, setToggleInspectionParagraphText] = useState(getDefaultParagraphText());
    const [toggleFitsToParagraphText, setToggleFitsToParagraphText] = useState(translator.getPlainTextPhrase('sandhills.tradepubwebsite.mvc.showasparagraph'));
    const mainImage = props.MediaModel && props.MediaModel.Media && props.MediaModel.Media.length > 0 && props.MediaModel.Media[0].MediaUrl ? props.MediaModel.Media[0].MediaUrl : '';
    const windowSize = useWindowSize();
    const currentWebsite = useRecoilValue(atoms.currentWebsite);

    const getToggledParagraphText = (toggledParagraphText) => {
        let text = toggledParagraphText == translator.getPlainTextPhrase('sandhills.tradepubwebsite.mvc.showasparagraph') ? translator.getPlainTextPhrase('sandhills.showastable') : translator.getPlainTextPhrase('sandhills.tradepubwebsite.mvc.showasparagraph');

        return text;
    }

    const toggleTable = (tableId, paragraphId) => {
        document.getElementById(tableId).classList.toggle('hide');
        document.getElementById(paragraphId).classList.toggle('hide')
    };

    const toggleTableClicked = (tableID, paragraphID, isInspectionToggle = false) => {
        toggleTable(tableID, paragraphID);

        if (isInspectionToggle) {
            setToggleInspectionParagraphText(getToggledParagraphText(toggleInspectionParagraphText));
        } else {
            setToggleSpecParagraphText(getToggledParagraphText(toggleSpecParagraphText));
        }
    };

    const toggleThumbnailClicked = () => {
        document.getElementById('print-thumbs').classList.toggle('hide');
        let text = toggleThumbnailText == translator.getPlainTextPhrase('sandhills.showthumbnails') ? translator.getPlainTextPhrase('sandhills.tradepubwebsite.mvc.hidethumbnails') : translator.getPlainTextPhrase('sandhills.showthumbnails');
        setToggleThumbnailText(text);
    };

    const toggleFitsToTableClicked = (tableID, paragraphID) => {
        toggleTable(tableID, paragraphID);
        let text = toggleFitsToParagraphText == translator.getPlainTextPhrase('sandhills.tradepubwebsite.mvc.showasparagraph') ? translator.getPlainTextPhrase('sandhills.showastable') : translator.getPlainTextPhrase('sandhills.tradepubwebsite.mvc.showasparagraph');
        setToggleFitsToParagraphText(text);
    };

    const openThisEmailModal = () => { };

    return (
        <div className='print-detail-wrapper'>
            <div className='print-detail-content'>
                {props.LogoUrl && <LazyLoadImage src={props.LogoUrl} className='dealer-header-title-logo' alt=""/>}
                <section className='print-detail-main-info'>
                    <div className='title-and-image'>
                        <div className='title-and-price'>
                            <h1 className='detail-title'>
                                {props.LotNumber && <><TranslationText tKey='sandhills.auctiontime.api.lotnumber' /> {props.LotNumber} - </>}{props.DisplayedListingTitle || props.ListingTitle}</h1>
                        </div>
                        <div className='main-img'>
                            <img className='print-this-img-main' src={mainImage} alt="" />
                        </div>
                    </div>
                    <div className='print-contact-information'>
                        <MainDetailPricing {...props.PricingInfo} auctionDetails={props.AuctionDetails} isPrintPage={props.IsPrintPage} IsPrivateParty={props.IsPrivateParty} />                        
                        {props.AuctionDetails && props.AuctionDetails.WebEndDateTime &&   
                            <>
                            {props.AuctionDetails.IsAuctionResult && currentWebsite.Site.IsAuctionTime ?
                                    <>                                    
                                        {props.AuctionDetails.BuyersPremiumData?.BuyersPremiumFee &&
                                        <div className='detail__sale-date'>
                                            <span className='detail__sale-date-label'><TranslationText tKey='sandhills.buyerspremiumincludedinprice' />:</span> <span className='detail__sale-date-text'>{props.AuctionDetails.BuyersPremiumData.BuyersPremiumFee}</span>
                                            </div>
                                        }
                                        {props.AuctionDetails.AuctionBiddingData?.NumberOfBids > 0 &&
                                            <div className='detail__sale-date'>
                                                <span className='detail__sale-date-label'><TranslationText tKey='sandhills.tradepubwebsite.mvc.numberofbids' />:</span> <span className='detail__sale-date-text'>{props.AuctionDetails.AuctionBiddingData.NumberOfBids}</span>
                                            </div>
                                        }
                                        {props.AuctionDetails.AuctionBiddingData?.StartingBidFormatted &&
                                            <div className='sale-date'>
                                                <span className='detail__sale-date-label'><TranslationText tKey='sandhills.openedat' />:</span> <span className='detail__sale-date-text'>{props.AuctionDetails.AuctionBiddingData.StartingBidFormatted}</span>
                                            </div>
                                        }
                                        
                                        <div className='detail__sale-date'>
                                        <span className='detail__sale-date-label'> <TranslationText tKey='sandhills.tradesites.mvc.auctionended' />:</span> <span className='detail__sale-date-text'>{props.AuctionDetails.AuctionDate}</span>
                                        </div>
                                    </>
                                    : props.AuctionDetails.IsAuctionResult ?
                                    <div className='detail__sale-date'>
                                        <span className='detail__sale-date-label'> <TranslationText tKey='sandhills.tradesites.mvc.auctionended' />:</span> <span className='detail__sale-date-text'>{props.AuctionDetails.AuctionDate}</span>
                                    </div>
                                    :
                                    <div className='detail__sale-date'>
                                        <span className='detail__sale-date-label'> <TranslationText tKey='sandhills.enddate' />:</span> <span className='detail__sale-date-text'>{props.AuctionDetails.AuctionDate}</span>
                                    </div>
                                }
                            </>
                            
                        }
                        {(props.ContactInfo?.ListingLocation) &&
                            <div className='detail__machine-location'>
                                <strong className='detail__machine-location-label-text'>{props.ContactInfo.ListingLocation.DisplayText}</strong>
                                <ThemedLink variant='text' size='small' sx={{ color: 'black' }} href={props.ContactInfo?.ListingLocation?.GoogleMapsUrl ? props.ContactInfo.ListingLocation.GoogleMapsUrl : ''} underline='hover' className={props.ContactInfo?.ListingLocation?.GoogleMapsUrl ? '' : 'anchor-no-link'} target='_blank'
                                    aria-label={props.ContactInfo?.ListingLocation?.GoogleMapsUrl && props.ContactInfo?.ListingLocation?.FullAddress ? (props.ContactInfo.ListingLocation.ShowStreetAddress ? props.ContactInfo.ListingLocation.FullAddress : '') + props.ContactInfo.ListingLocation.FormattedLocation + " (" + translator.translate('sandhills.opensinanewtab') + ")" : (props.ContactInfo.ListingLocation.ShowStreetAddress ? props.ContactInfo.ListingLocation.FullAddress : '') + props.ContactInfo.ListingLocation.FormattedLocation}>
                                    <>
                                        {props.ContactInfo.ListingLocation.ShowStreetAddress &&
                                            <span className='detail__machine-location-address'>
                                                {props.ContactInfo.ListingLocation.FullAddress}
                                            </span>}
                                        <>
                                            {props.ContactInfo.ListingLocation.FormattedLocation}
                                        </>
                                        {props.ContactInfo?.ListingLocation?.GoogleMapsUrl && props.ContactInfo?.ListingLocation?.FullAddress &&
                                            <>
                                                <Icon baseClassName='fas' className='fa-external-link-alt' />
                                            </>}
                                    </>
                                </ThemedLink>
                            </div>}
                        {props.ContactInfo && props.ContactInfo !== 'undefined' && !props.ShowWholesaleContactInfoOnly &&
                            <DealerInfo
                                {...props.ContactInfo}
                                ListingBaseCatID={props.BaseCatID}
                                ListingCategory={props.CategoryInformation.CategoryID}
                                openEmailModal={openThisEmailModal}
                                contactType={contactType.Retail}
                                windowSize={windowSize}
                                isPrintPage={true}
                            />}
                        {props.WholesaleContactInfo && props.WholesaleContactInfo !== 'undefined' && !props.IsPrivateParty &&
                            <DealerInfo
                                {...props.WholesaleContactInfo}
                                ListingBaseCatID={props.BaseCatID}
                                ListingCategory={props.CategoryInformation.CategoryID}
                                openEmailModal={openThisEmailModal}
                                contactType={contactType.Wholesale}
                                windowSize={windowSize}
                                isPrintPage={true}
                            />}
                    </div>
                </section>
                {props.MediaModel.Media && props.MediaModel.Media.length > 0 &&
                    <section className='thumbnails'>
                        <div id='print-thumbs' className='print-this-thumbnails'>
                            {props.MediaModel.Media.map(image =>
                                <img src={image.ThumbnailUrl} className='print-this-thumbnail' alt="" />)}
                        </div>
                        <div className='print-this-hide-toggle'>
                            <a id='ThumbnailToggle' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); toggleThumbnailClicked(); } }} onClick={toggleThumbnailClicked}>{toggleThumbnailText}</a>
                        </div>
                    </section>}
                {props.DescriptionSpec &&
                    <div>
                        <h3 className='specifications-heading'><TranslationText tKey='sandhills.description' /></h3>
                        <section id='descriptionParagraph' className='print-specs-table'>
                            <span className='print-data-value'>{props.DescriptionSpec.Value}</span>
                        </section>
                    </div>}
                <h3 className='specifications-heading'><TranslationText tKey='sandhills.tradepubwebsite.mvc.specifications' /></h3>
                <section id='specsTable' className='print-specs-table'>
                    {props.SpecsExceptDescription && props.SpecsExceptDescription.length > 0 &&
                        props.SpecsExceptDescription.map(spec =>
                            <div className='print-data-row'>
                                <span className='print-data-label'>{spec.LabelDisplayText}</span>
                                <span className='print-data-value'>{spec.Value}</span>
                            </div>)}
                </section>
                <section id='specsParagraph' className='print-specs-paragraph hide'>
                    {props.SpecsExceptDescription && props.SpecsExceptDescription.length > 0 &&
                        props.SpecsExceptDescription.map(spec =>
                            <div>
                                <span className='print-paragraph-spec-key'>
                                    {spec.LabelDisplayText}
                                </span>
                                <span className='print-paragraph-spec-value'>
                                    {spec.Value}
                                </span>
                                <span className='divider'>|</span>
                            </div>)}
                </section>
                <div className='specs-toggle'>
                    <a id='specDisplayToggle' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); toggleTableClicked('specsTable', 'specsParagraph'); } }} onClick={() => toggleTableClicked('specsTable', 'specsParagraph')}>
                        {toggleSpecParagraphText}</a>
                </div>
                {props.InspectionVM && props.InspectionVM.ShowInspections &&
                    <div>
                        <InspectionList Inspections={props.InspectionVM.Inspections} LangID={props.SiteLangID} isPrint />
                        <div className='specs-toggle'>
                            <a id='inspectionDisplayToggle' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); toggleTableClicked('inspectionsTable', 'inspectionsParagraph', true); } }} onClick={() => toggleTableClicked('inspectionsTable', 'inspectionsParagraph', true)}>
                                {toggleInspectionParagraphText}
                            </a>
                        </div>
                    </div>}
                {props.GroupedInfo && props.GroupedInfo.length > 0 &&
                    <div>
                        <section className='grouped-info-wrap'>
                            <h3 className='specifications-heading'>
                                <TranslationText tKey='sandhills.tradepubwebsite.mvc.attachmentfitsto' />
                            </h3>
                            <section id='grouped-info-table-0' className='fits-to-table print-specs-table'>
                                {props.GroupedInfo.map(item =>
                                    <div className='print-data-row'>
                                        <span className='print-data-label'>{item.Key}</span>
                                        <span className='print-data-value'>{item.Value && item.Value.length > 0 &&
                                            (item.Value.length == 1 ?
                                                <span>{item.Value[0]}</span> :
                                                item.Value.map((model, i) =>
                                                    <>
                                                        {(i + 1) == item.Value.length ?
                                                            <span>{model}</span> :
                                                            <span>{model + ', '}</span>}
                                                    </>))}
                                        </span>
                                    </div>)}
                            </section>
                            <section id='grouped-info-paragraph-0' className='fits-to-paragraph print-specs-paragraph hide'>
                                {props.GroupedInfo.map(item =>
                                    <div className='print-data-row'>
                                        <span className='print-data-label'>{item.Key}</span>
                                        <span className='print-data-value'>{item.Value && item.Value.length > 0 &&
                                            (item.Value.length == 1 ?
                                                <span>{item.Value[0]}</span> :
                                                item.Value.map((model, i) =>
                                                    <>
                                                        {(i + 1) == item.Value.length ?
                                                            <span>{model}</span> :
                                                            <span>{model + ', '}</span>}
                                                    </>))}
                                        </span>
                                        <span className='divider'>|</span>
                                    </div>)}
                            </section>
                        </section>
                        <div className='specs-toggle'>
                            <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); toggleFitsToTableClicked('grouped-info-table-0', 'grouped-info-paragraph-0'); } }} onClick={() => toggleFitsToTableClicked('grouped-info-table-0', 'grouped-info-paragraph-0')}>{toggleFitsToParagraphText}</a>
                        </div>
                    </div>}
            </div>
        </div>
    );
};

export default PrintDetail;
global.PrintDetail = PrintDetail;